import React from "react";
import { Offer } from "@duffel/components";
import { Box, Divider, Stack, styled, Typography } from "@mui/material";
import EMIRATES from "../../assets/emirates.png";
import countries from "../../data/countrie";

const LightText = styled(Typography)({
  color: "gray",
  fontSize: "14px",
  fontWeight: "100",
});
const BoldText = styled(Typography)({
  color: "#000000",
  fontSize: "15px",
  fontWeight: "bold",
});
const SubTitle = styled(Typography)({
  fontSize: "13px",
});
type Props = {
  offer: any;
};
const SliceCard = ({ offer }: Props) => {
  const formatDepartAndArriveDate = (date: string): string[] => {
    const fDate = date.split("T");

    return [new Date(fDate[0]).toDateString(), fDate[1]];
  };
  const countryNameFromCcode = (cCode: string): string => {
    const cName = countries.filter(
      (pays) => pays.cca2.toLowerCase() === cCode.toLowerCase()
    )[0];

    return cName.name.common;
  };
  const convertDuration = (dur: string): string => {
    const duration = dur.replace("PT", "").replace("M", "mins");

    return duration.toLowerCase();
  };
  const calculateAndReturnStopDuration = (
    segments: any,
    currentIdx: number
  ): any => {
    const nextIdx = currentIdx + 1;

    const lastArrival = segments[currentIdx].arriving_at;
    console.log("THE SEGMENTS PASSED: ", segments);
    console.warn("====================================");
    console.warn("NEXT INDEX: ", nextIdx);
    console.log("NEXT SEGMENTS: ", segments[nextIdx]);
    console.warn("====================================");
    const nextDeparture = segments[nextIdx].departing_at;

    const last = new Date(lastArrival).getTime();
    const next = new Date(nextDeparture).getTime();
    var diff = {
      sec: 0,
      min: 0,
      hour: 0,
    };
    const elapsed = next - last;
    let tmp = Math.floor(elapsed / 1000); // Nombre de secondes entre les 2 dates
    diff.sec = tmp % 60; // Extraction du nombre de secondes

    tmp = Math.floor((tmp - diff.sec) / 60); // Nombre de minutes (partie entière)
    diff.min = tmp % 60; // Extraction du nombre de minutes

    tmp = Math.floor((tmp - diff.min) / 60); // Nombre d'heures (entières)
    diff.hour = tmp % 24;
    return diff;
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginBottom: "15px",
      }}>
      <Typography variant="h6" component="code">
        {offer.slices[0].origin.city_name} To{" "}
        {offer.slices[0].destination.city_name}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
        }}>
        <SubTitle
          variant="body1"
          sx={{
            color: "#1AA95E",
          }}>
          {offer.slices[0].segments.length <= 1
            ? "Direct"
            : `${offer.slices[0].segments.length - 1} Stops`}
        </SubTitle>
        <Divider orientation="vertical" flexItem />
        <SubTitle variant="body1">
          {convertDuration(offer.slices[0].duration)}
        </SubTitle>
        <Divider orientation="vertical" flexItem />
        <SubTitle variant="body1">{offer.slices[0].fare_brand_name}</SubTitle>
        <Divider orientation="vertical" flexItem />
        <SubTitle variant="body1">
          {
            formatDepartAndArriveDate(
              offer.slices[0].segments[0].departing_at
            )[0]
          }
        </SubTitle>
      </Box>
      {offer.slices[0].segments.map((seg: any, segIdx: number) => (
        <>
          <Stack
            key={segIdx}
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            sx={{
              marginTop: "5px",
            }}>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}>
              <img
                src={offer.owner.logo_symbol_url}
                style={{
                  width: "34px",
                  height: "34px",
                }}
              />
              <div>
                <BoldText
                  style={{
                    color: "#3B3E44",
                  }}>
                  {offer.owner.name}
                </BoldText>
                <BoldText
                  style={{
                    color: "#84878B",
                  }}>
                  {seg.aircraft.name}
                </BoldText>
              </div>
            </Stack>
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="flex-start"
              spacing={0}>
              <BoldText>
                {formatDepartAndArriveDate(seg.departing_at)[1]}
              </BoldText>
              <LightText variant="body1">
                {formatDepartAndArriveDate(seg.departing_at)[0]}
              </LightText>
              <LightText variant="body1">
                {offer.slices[0].origin.name}
              </LightText>
              <LightText variant="body1">
                {countryNameFromCcode(offer.slices[0].origin.iata_country_code)}
              </LightText>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={3}>
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                spacing={0}>
                <LightText variant="body1">
                  {convertDuration(seg.duration)}
                </LightText>
                <LightText variant="body1">........................</LightText>
              </Stack>
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                spacing={0}>
                <BoldText>
                  {formatDepartAndArriveDate(seg.arriving_at)[1]}
                </BoldText>
                <LightText variant="body1">
                  {formatDepartAndArriveDate(seg.arriving_at)[0]}
                </LightText>
                <LightText variant="body1">
                  {offer.slices[0].destination.name}
                </LightText>
                <LightText variant="body1">
                  {countryNameFromCcode(
                    offer.slices[0].destination.iata_country_code
                  )}
                </LightText>
              </Stack>
            </Stack>
          </Stack>
          <>
            {segIdx < offer.slices[0].segments.length - 1 && (
              <Box
                sx={{
                  padding: "0px",
                  //  backgroundColor: "#878CFF",
                  borderRadius: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#878CFF",
                  fontSize: "14px",
                }}>
                {"Stops "}
                {
                  calculateAndReturnStopDuration(
                    offer.slices[0].segments,
                    segIdx
                  ).hour
                }
                {"hours"}
                {
                  calculateAndReturnStopDuration(
                    offer.slices[0].segments,
                    segIdx
                  ).min
                }
                {"mins"}
                {
                  calculateAndReturnStopDuration(
                    offer.slices[0].segments,
                    segIdx
                  ).sec
                }
              </Box>
            )}
          </>
        </>
      ))}

      {/*  
      
      
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 3,
          marginTop: "15px",
        }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}>
          <BoldText>Passager:</BoldText>
          <LightText variant="body1">Adult</LightText>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}>
          <BoldText>Check-In</BoldText>
          <LightText variant="body1">20Kgs</LightText>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}>
          <BoldText>Cabin</BoldText>
          <LightText variant="body1">7 kg</LightText>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}>
          <BoldText>Meals</BoldText>
          <LightText variant="body1">Meals Not Available</LightText>
        </Box>
      </Box>
      */}
    </Box>
  );
};

export default SliceCard;
